<template>
  <div class="search-box">
    <div>
      <el-input
        class="search_box"
        :placeholder="searchTips"
        prefix-icon="el-icon-search"
        v-model="input"
        @blur="onBlur"
      >
        <!-- @keypress.enter.native="enterKey" -->
        <el-select slot="prepend" v-model="optionVal" :placeholder="optionVal" @change="optionChange" style="min-width: 130px">
          <el-option label="Gene" value="Gene" />
          <el-option label="Cell type" value="Cell type" />
          <el-option label="Species" value="Species" />
          <el-option label="Brain region" value="Brain region" />
          <el-option label="Disease" value="Disease" />
        </el-select>
      </el-input>
    </div>
    <div
     class="searchRes"
     v-show="show"
    >
      <div v-show="loading" class="loading" v-loading="loading" element-loading-text="Searching..." />
      <div v-show="!loading" id="resDiv">
        <!-- <ul id="resUl" style="list-style: none; text-aglin: left;"></ul> -->
      </div>
    </div>
  </div>
</template>

<script>
import { searchAll } from '@/api/allWebSite'

export default {
  data () {
    return {
      optionVal: 'Gene',
      input: null,
      loading: true,
      show: false
    }
  },
  watch: {
    input: {
      handler () {
        if (this.input.length < 2) {
          this.show = false
          let listDom = document.getElementById('resDiv')
          listDom.innerHTML = ''
          this.loading = false
        } else {
          let listDom = document.getElementById('resDiv')
          listDom.innerHTML = ''
          this.show = false
          this.loading = true
          if (!this.show) {
            this.show = true
            this.handleSearch()
          }
        }
      }
    },
    optionVal: {
      handler () {
        this.input = null
        let listDom = document.getElementById('resDiv')
        listDom.innerHTML = ''
      }
    }
  },
  computed: {
    searchTips () {
      switch (this.optionVal) {
        case 'Gene':
          return 'Marker gene';
          break;
        case 'Cell type':
          return 'Cell type name';
          break;
        case 'Species':
          return 'Species name';
          break;
        case 'Brain region':
          return 'Brain region';
          break;
        case 'Disease':
          return 'Disease';
          break;

      }
    }
  },
  methods: {
    handleSearch () {
      // searchAll(this.optionVal, this.input).then(res => {
      //   this.resList(res.data.searchResult)
      //   this.loading = false
      // }).then(() => {
      //   this.resListStyle()
      // })
      searchAll(this.optionVal, this.input).then(res => {
        this.resList(res.data.searchResult)
        this.loading = false
      }).then(() => {
        this.resListStyle()
      })
    },
    optionChange (val) {
      // console.log(val, this.optionVal)
    },
    resList (searchRes) {
      let listDiv = document.getElementById('resDiv')
      listDiv.innerHTML = ''
      if (searchRes.length === 0) {
        let listUl = document.createElement('div')
        listDiv.appendChild(listUl)
        listUl.style.width = '386.45px'
        listUl.style.height = '100px'
        listUl.style.lineHeight = '100px'
        listUl.style.backgroundColor = '#fffafa'
        listUl.innerText = 'No result'
      } else {
        let listUl = document.createElement('ul')
        listDiv.appendChild(listUl)
        listUl.setAttribute('id', 'resUl')
        listUl.style.textAlign = 'left'
        listUl.style.listStyle = 'none'
        let listDom = document.getElementById('resUl')
        let liHtml = ''
        if (this.optionVal === 'Gene') {
          for (let i = 0; i < searchRes.length; i++) {

              // let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="http://localhost:8089/#/taxon/' + searchRes[i].taxon_rank_level + '/' + searchRes[i].ncbi_taxon_id + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].name + ' | ' + searchRes[i].ncbi_taxon_id + ' | ' + searchRes[i].taxon_rank_level + '</a></li>'
            let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="https://scbrainmap.sysneuro.net/#/markers/' + searchRes[i].Gene + '/' + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].Gene  + ' | ' + searchRes[i].Species +  ' | Gene' + '</a></li>'
            liHtml += li

          }
        } else if (this.optionVal === 'Cell type') {
          for (let i = 0; i < searchRes.length; i++) {
            // let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="http://localhost:8089/#/phenotypeDetail/' + searchRes[i].uid + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].uid + ' | ' + searchRes[i].term + ' | ' + 'phenotype</a></li>'

              let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem">' +
                '<a href="https://scbrainmap.sysneuro.net/#/celltypes/cluster/' + searchRes[i].Cluster + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].Cluster + ' | ' + searchRes[i].Species + '</a></li>'
              liHtml += li

          }
        } else if (this.optionVal === 'Brain region') {
          for (let i = 0; i < searchRes.length; i++) {

              // let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="http://localhost:8089/#/site/gut/The%20large%20intestine" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].BodySite + ' | ' + 'BodySite</a></li>'
              let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem">' +
                '<a href="https://scbrainmap.sysneuro.net/#/brainregions/regions/' + searchRes[i].Brain_region + '/' + searchRes[i].Species + '"target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].Brain_region + ' | ' + searchRes[i].Species + '</a></li>'
              liHtml += li

          }
        } else if (this.optionVal === 'Species') {
          for (let i = 0; i < searchRes.length; i++) {
            // let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="http://localhost:8089/#/data/project/' + searchRes[i]['NCBI\xa0Project\xa0ID'] + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i]['NCBI\xa0Project\xa0ID'] + ' | ' + 'project</a></li>'
            let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="https://scbrainmap.sysneuro.net/#/celltypes/' + searchRes[i].Species + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].Species + ' | ' + 'Species</a></li>'
            liHtml += li
          }
        } else {
          for (let i = 0; i < searchRes.length; i++) {
            // let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="http://localhost:8089/#/data/run/' + searchRes[i].accession_id + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].accession_id + ' | ' + 'run</a></li>'
            let li = '<li style="text-align:left;padding-left: 10px;" class="searchItem"><a href="https://scbrainmap.sysneuro.net/#/Conditions/Disease/' + searchRes[i].Disease + '" target="_blank" style="text-decoration:none; font-size: 14px;" >' + searchRes[i].Disease + ' | ' + 'Disease</a></li>'
            liHtml += li
          }
        }
        listDom.innerHTML = liHtml
      }
      // console.log(liHtml)
    },
    resListStyle () {
      let searchItem = document.getElementsByClassName('searchItem')
      for (let i = 0; i < searchItem.length; i++) {
        searchItem[i].onmouseover = function () {
          this.style.backgroundColor = 'lightBlue'
        }
        searchItem[i].onmouseout = function () {
          this.style.backgroundColor = 'transparent'
        }
      }
    },
    onBlur () {
      let that = this
      setTimeout(function () {
        that.show = false
        let listDom = document.getElementById('resDiv')
        listDom.innerHTML = ''
      }, 500)
    }
    // enterKey (e) {
    //   if (e.keyCode === 13) {
    //     this.loading = true
    //     let listDom = document.getElementById('resDiv')
    //     listDom.innerHTML = ''
    //     this.show = false
    //     if (!this.show) {
    //       this.show = true
    //       this.handleSearch()
    //     }
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
 .search-box {
   height: 50px;
   padding-top: 40px;
   margin-left: 0px;
   padding-right: 15px;
   padding-left: 15px;
   z-index: 999;
 }
 .searchRes {
  //  display: none;
   width: 363.33px;
   background-color: #fffafa;
   border: 1px solid transparent;
   border-radius: 5px;
   z-index: 999;
 }
//  #resUl {
//    list-style: none;
//    text-align: left;
//  }
 .loading {
   width: 363.33px;
   height: 200px;
   background-color: #fffafa;
   border: 1px solid transparent;
   border-radius: 5px;
   z-index: 999;
 }
 li {
   list-style: none;
   text-align: left;
 }
 .searchItem:hover {
   background-color: lightblue;
 }
 ul {
   padding: 5px 0 0 0;
 }
//  .search-box .el-select .el-input {
//     width: 200px !important;
//   }
</style>



// WEBPACK FOOTER //
// src/layout/components/Header/components/serachBox.vue